import ProjectCard from '../components/ProjectCard';
import Title from '../components/Title';
import './styles/projectsLayout.css'


/**
 * Component representing the projects layout of the application.
 * @returns {JSX.Element} The ProjectsLayout component.
 */

export default function ProjectsLayout({fadeOut, actionHandler}) {
    return (
        <div className={`projects-layout${fadeOut ? " fade-out" : ""}`}>
            <div style={{
                padding: "0 16px",
                width: "100%"
            }}>
                <Title content={"Découvrir mes projets"} />
            </div>
            <div className="sticky-wrapper">
                <ProjectCard
                accentColor={"#ad815c"}
                image={"https://voidsplit.github.io/SpeedCoding-website-Les-Devs-du-Dimanche-002/images/categorie1.jpg"}
                imageAlt={"Image de décoration"}
                redirect={"https://voidsplit.github.io/Chez-Teemo/"}
                name={"Chez Teemo"}
                description={"Bar et restaurant à champignons fictif atypique "} />

                <ProjectCard
                accentColor={"#ad815c"}
                image={"https://voidsplit.github.io/SpeedCoding-website-Les-Devs-du-Dimanche-002/images/categorie2.jpg"}
                imageAlt={"Image de décoration"}
                redirect={"https://github.com/VoidSplit/voidsplit-select-component"}
                name={"NPM Select Component"}
                description={"Librairie NPM d'un menu déroulant React basé sur celui de JQuery"} />

                <ProjectCard
                accentColor={"#ad815c"}
                image={"https://voidsplit.github.io/SpeedCoding-website-Les-Devs-du-Dimanche-002/images/categorie3.jpg"}
                imageAlt={"Image de décoration"}
                redirect={"https://voidsplit.github.io/Yet-Another-Discord-Embed-Generator/"}
                name={"Discord embed Generator"}
                description={"Outil pour générer des Embeds pour des Bots Discord, peut générer du code dans plusieurs langages"} />

                <ProjectCard
                accentColor={"#ad815c"}
                image={"https://voidsplit.github.io/SpeedCoding-website-Les-Devs-du-Dimanche-002/images/categorie4.jpeg"}
                imageAlt={"Image de décoration"}
                redirect={"https://voidsplit.github.io/Integration-challenges/apps/montblanc/index.html"}
                name={"MontBlanc création"}
                description={"Projet d'intégration d'une maquette de composition en grille"} />

            </div>
            <div className="see-more cursor-detect-hover">
                <div className="cursor-hoverable">
                    <div className='link' onClick={() => {actionHandler("/projects")}}>Voir plus de projets <span></span></div>
                </div>
            </div>
        </div>
    );
};